import { render, staticRenderFns } from "./DetalleNotificacion.vue?vue&type=template&id=5b7a4924&"
import script from "./DetalleNotificacion.vue?vue&type=script&lang=ts&"
export * from "./DetalleNotificacion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports